import TimeUtil from 'utils/time-util'
import PropTypes from 'prop-types'
import ActiveBadge from 'domains/voucher/atoms/active-badge'
import { VoucherShowOnCheckoutBadge } from 'domains/voucher'

const propTypes = {
  voucherRule : PropTypes.object,
  onRowClick  : PropTypes.func
}

/**
 * Row to show some attribute of Customer::Cart::Voucher::Rule
 * @param {Object} voucherRule - Customer::Cart::Voucher::Rule
 * @param {Function} onRowClick - Function that triggered on row click
 */

const VoucherRuleTableRow = ({
  voucherRule,
  onRowClick
}) => {

  const vouchers = voucherRule.vouchers

  const isVouchersEmpty = vouchers.length === 0

  const isVouchersMoreThanOne = vouchers.length > 1

  return (
    <tr
      style={{ cursor: 'pointer' }}
      onClick={ () => onRowClick(voucherRule.id) }
    >
      <td>
        { voucherRule.id } <br/>
      </td>
      <td>{ voucherRule.name }</td>
      <td>
        {
          isVouchersEmpty && '-'
        }
        {
          isVouchersMoreThanOne
            ? vouchers[0]?.code
            : `${vouchers[0]?.code}...`
        }

      </td>
      <td>{ TimeUtil.format(voucherRule.from_date) }</td>
      <td>{ TimeUtil.format(voucherRule.to_date) }</td>
      <td>
        <ActiveBadge isActive={ voucherRule.is_active } />
      </td>
      <td>
        <VoucherShowOnCheckoutBadge showOnCheckout={ voucherRule.show_on_checkout } />
      </td>
      <td>{ voucherRule.times_used }</td>
    </tr>
  )
}

VoucherRuleTableRow.propTypes = propTypes

export default VoucherRuleTableRow